import React from "react";
import { Pie } from "react-chartjs-2";
import "./style.css";

const PieChart = ({ chartData, title }) => {
  return (
    <div className="chart-container">
      <Pie
        datasetIdKey="id"
        data={chartData}
        options={{
          plugins: {
            title: {
              display: true,
              text: title,
            },
            legend: {
              display: true,
            },
          },
        }}
      />
    </div>
  );
};
export default PieChart;
